module.exports = __webpack_public_path__ + "assets/img/small_drop_icon.2ce8c8f7.svg";